import React from 'react';
import { Box } from '@material-ui/core';
import { TitleButton } from 'components/ReportsModule/components/PrmReport/common/PrmTitleRow';
import { AssessmentSubmodulesNames } from 'components/ReportsModule/types';
import { moduleNameMap } from '../keyboarding-report-util';

const modules = [
  {
    name: AssessmentSubmodulesNames.ALL_MODULES,
    id: -1
  },
  {
    name: AssessmentSubmodulesNames.MODULE_1_MATH,
    id: 4
  },
  {
    name: AssessmentSubmodulesNames.MODULE_2_MATH_ELA,
    id: 5
  },
  {
    name: AssessmentSubmodulesNames.MODULE_3_ELA,
    id: 4
  }
];

type Props = {
  onChange: (selectedId: any) => void;
  selectedModule: any;
};

const ModuleTabSelector: React.FC<Props> = ({ onChange, selectedModule }) => {
  return (
    <Box display="flex">
      {modules?.map((x, idx) => (
        <Box padding={1} key={`module_tab_selector_${idx}`}>
          <TitleButton
            name={moduleNameMap[x.name]!}
            selected={selectedModule === x.name}
            handleClick={() => onChange(x.name)}
          />
        </Box>
      ))}
    </Box>
  );
};

export default ModuleTabSelector;
